import { useEffect } from 'react';
import { FormControl } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as DatePickerType } from '@/schemas/sceneDataSchema';
import { Controller, UseFormReturn } from 'react-hook-form';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFieldBinding, seedFormFromStore } from '@/hooks/use-field-binding';

const formatObfuscated = (dob: string): string => {
  const [year, month, day] = dob.split('-');
  return `${month}/${day}/${year}`;
};

export const DatePickerFormElement = ({ form, component }: { form: UseFormReturn; component: DatePickerType }) => {
  const key = encodeFieldKey(component);
  const binding = useFieldBinding(component);
  const obfuscatedDob = component.value?.includes('*') ? formatObfuscated(component.value ?? '') : undefined;
  const labelText = obfuscatedDob ?? component.label;

  useEffect(() => {
    seedFormFromStore(form, key, binding.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      control={form.control}
      name={key}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          fullWidth
          error={!!error}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={labelText}
              defaultValue={component.value && !component.value.includes('*') ? new Date(component.value) : undefined}
              onChange={(value) => {
                if ((value instanceof Date && !isNaN(value.getTime())) || value === null) {
                  const date = value?.toISOString() ?? null;
                  field.onChange(date);
                  binding.sync(date ?? '');
                }
              }}
              onClose={() => binding.onBlur()}
              slotProps={{
                field: { clearable: true },
                textField: {
                  error: !!error,
                  helperText: error?.message,
                  onBlur: () => binding.onBlur(),
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      )}
    />
  );
};
